__turbopack_context__.v({
  "active": "StickyHeader-module-scss-module__fo6JmG__active",
  "brand": "StickyHeader-module-scss-module__fo6JmG__brand",
  "closeButton": "StickyHeader-module-scss-module__fo6JmG__closeButton",
  "desktopControls": "StickyHeader-module-scss-module__fo6JmG__desktopControls",
  "desktopNav": "StickyHeader-module-scss-module__fo6JmG__desktopNav",
  "fadeIn": "StickyHeader-module-scss-module__fo6JmG__fadeIn",
  "headerContent": "StickyHeader-module-scss-module__fo6JmG__headerContent",
  "mobileControls": "StickyHeader-module-scss-module__fo6JmG__mobileControls",
  "mobileMenuButton": "StickyHeader-module-scss-module__fo6JmG__mobileMenuButton",
  "mobileNav": "StickyHeader-module-scss-module__fo6JmG__mobileNav",
  "mobileNavLink": "StickyHeader-module-scss-module__fo6JmG__mobileNavLink",
  "mobileOverlay": "StickyHeader-module-scss-module__fo6JmG__mobileOverlay",
  "mobileSidebar": "StickyHeader-module-scss-module__fo6JmG__mobileSidebar",
  "mobileSidebarHeader": "StickyHeader-module-scss-module__fo6JmG__mobileSidebarHeader",
  "navLink": "StickyHeader-module-scss-module__fo6JmG__navLink",
  "scrolled": "StickyHeader-module-scss-module__fo6JmG__scrolled",
  "slideIn": "StickyHeader-module-scss-module__fo6JmG__slideIn",
  "stickyHeader": "StickyHeader-module-scss-module__fo6JmG__stickyHeader",
});
